import "./index.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom/client";
import configureStore from "./store";
import { initBrowserSessionGuard } from "./utils/browserSessionGuard";
import reportWebVitals from "./reportWebVitals";

// when tab close local storage clear and user would be logout
// if (!sessionStorage.getItem("tab_alive")) localStorage.clear();
// sessionStorage.setItem("tab_alive", "true");


// when broser closes then logout 
initBrowserSessionGuard();

const { persister, store } = configureStore();
export const queryClient: any = new QueryClient();
const PGate = PersistGate as any;

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);
root.render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<Provider store={store}>
				<PGate loading={null} persistor={persister}>
					<App />
				</PGate>
			</Provider>
		</QueryClientProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(consoleValue))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
